<template lang="pug">
  dialogs(:show.sync="visible" :option="{ size: 'lg', headerClass: 'type-2' }")
    .wrap
      template(v-if="step === 1")
        .warning
          icon.icon(name="exclamation-triangle" width="50" height="50")
          span ※ {{$t('device_page.public_access_warning')}} ※
        .box
          .msg.text-left(v-html="$func.htmlBr(form.public_place_alert)")
        .modal-footer
          b-btn(size="sm" variant="primary" @click="step++" pill) {{$t('agree_and_connect')}}
          b-btn(size="sm" @click="visible = false" pill) {{$t('agree_and_connect')}}
      template(v-if="step === 2")
        .title {{$t('security_agreement')}}
        .box
          .msg.text-left(v-html="$func.htmlBr(form.security_content)")
        .modal-footer
          b-btn(size="sm" variant="primary" @click="step++" pill) {{$t('agree_and_connect')}}
          b-btn(size="sm" @click="visible = false" pill) {{$t('agree_and_connect')}}
</template>

<script>
import { RemoteAccessAgreementAPI } from "@/api"
import Dialogs from "@/components/mixins/dialog/index.vue"

export default {
  name: "dialogAccess",
  components: {
    Dialogs,
  },
  watch: {
    step(val) {
      if (val > this.maxStep) {
        this.visible = false
        this.cb("submit")
      }
    },
  },
  data() {
    return {
      visible: false,
      step: 1,
      maxStep: 2,
      form: {},
      cd() {},
    }
  },
  created() {
    this.AppState.$on("show-security-dialog", (data, cb) => {
      if (typeof cb === "function") this.cb = cb
      this.fetchData()
    })
  },
  methods: {
    submit() {
      this.cb("submit")
    },
    fetchData() {
      RemoteAccessAgreementAPI.get().then(res => {
        const { objects } = res.data
        this.form = objects
        if (objects.flag_public_place_alert === 1) {
          this.step = 1
          this.maxStep = 1
          if (objects.flag_security_agreement === 1) {
            this.maxStep = 2
          }
        } else {
          if (objects.flag_security_agreement === 1) {
            this.step = 2
            this.maxStep = 2
          } else {
            this.cb("submit")
            return
          }
        }
        this.visible = true
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.wrap {
  padding: 30px;
}
header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
}
h1 {
  font-size: 20px;
}
.title {
  font-size: 19px;
  text-align: center;
  padding-bottom: 20px;
}
.content {
  padding: 0 0 20px;
}
.btn-secondary {
  color: #6f6f6f;
  border-color: #6f6f6f;
  background-color: #fff;
  text-align: center;
}
.msg {
  padding-left: 20px;
  padding-right: 20px;
}
.btns.text-center {
  margin-top: 20px;
  
  button {
    min-width: 60px;
  }
  
  button + button {
    margin-left: 10px;
  }
}
</style>
